import React from "react";

import { Icon } from "../Icon";
import { HeaderWrapper, NavigationButton, Title } from "./styles";
import { DatePickerHeaderProps } from "./types";

/**
 * Componente DatePickerTop
 *
 * Cabeçalho de um seletor de datas com botões de navegação entre os meses e exibição do mês/ano atual.
 *
 * @param {string} month - Nome do mês atual exibido no cabeçalho.
 * @param {string} year - Ano atual exibido no cabeçalho.
 * @param {() => void} [onPreviousMonth] - Função executada ao clicar no botão de voltar ao mês anterior.
 * @param {() => void} onNextMonth - Função executada ao clicar no botão de avançar para o próximo mês.
 */
export const DatePickerTop: React.FC<DatePickerHeaderProps> = ({
  month,
  year,
  onPreviousMonth,
  onNextMonth,
}) => (
  <HeaderWrapper aria-label="Date Picker Header">
    {onPreviousMonth && (
      <NavigationButton onClick={onPreviousMonth} aria-label="Previous month">
        <Icon
          library="md"
          name="MdKeyboardArrowLeft"
          color="black"
          size="large"
        />
      </NavigationButton>
    )}
    <Title>
      <span>{month}</span>
      <span>{year}</span>
    </Title>
    <NavigationButton onClick={onNextMonth} aria-label="Next month">
      <Icon
        library="md"
        name="MdKeyboardArrowRight"
        color="black"
        size="large"
      />
    </NavigationButton>
  </HeaderWrapper>
);
